/* B Free Japan - custom reviews section (sections/bfree-reviews.liquid). Added 2026-10.
   - First reviews: parsed from the inert Judge.me metafield copy in the page (no network).
   - More reviews: shown with the "もっと見る" button; fetched from the official Judge.me
     widget endpoint with the PUBLIC token (the first page is prefetched when the section
     comes near the screen). No auto-scroll. A failed load can be retried with the button.
   - Translations (non-Japanese reviews): 1) Judge.me metafield, 2) Judge.me translation
     service (the same one the Judge.me widget uses), 3) browser built-in translator.
   - "レビューを書く" opens the Judge.me review form (the Judge.me widget must stay ON;
     it is hidden with CSS on pages that have this section).
   - All customer text is inserted with textContent (never innerHTML). */
(function () {
  'use strict';

  var API = 'https://api.judge.me/api/v1/widgets/product_review';
  var PER_PAGE = 20;
  var STEP = 6;
  var TRANSLATE_API = 'https://api.judge.me/api/review_translations';

  function init(root) {
    if (!root || root.getAttribute('data-bfree-ready') === '1') { return; }
    root.setAttribute('data-bfree-ready', '1');

    var columnsEl = root.querySelector('[data-columns]');
    var state = {
      pool: [],
      ids: {},
      translations: readTranslations(root),
      sort: 'featured',
      shown: STEP,
      page: 0,
      exhausted: false,
      loading: null,
      error: false,
      displayed: [],
      total: parseInt(root.getAttribute('data-count'), 10) || 0,
      token: root.getAttribute('data-token') || '',
      handle: root.getAttribute('data-handle') || '',
      shop: root.getAttribute('data-shop') || ''
    };
    if (!state.token || !state.handle || !state.shop) { state.exhausted = true; }

    var initial = parseReviewsFromHtml(readTemplate(root));
    addReviews(state, initial);
    applyMetafieldTranslations(state, initial);
    if (state.pool.length >= state.total) { state.exhausted = true; }

    setupWriteReview(root);
    hideNativeWidgetFallback();
    if (!columnsEl) { return; }

    render(root, columnsEl, state);
    setupSort(root, columnsEl, state);
    setupMore(root, columnsEl, state);
    setupPrefetch(root, state);

    /* Initial reviews without a saved translation: ask the Judge.me translation service. */
    translateWithJudgeme(state, initial, 1).then(function (changed) {
      if (changed) { render(root, columnsEl, state); }
    });

    var lastCols = colCount();
    window.addEventListener('resize', debounce(function () {
      var now = colCount();
      if (now !== lastCols) { lastCols = now; render(root, columnsEl, state); }
    }, 250));
  }

  /* ---------- data ---------- */

  function readTemplate(root) {
    var tpl = root.querySelector('template[data-initial-reviews]');
    if (!tpl) { return ''; }
    return tpl.innerHTML || '';
  }

  function readTranslations(root) {
    var el = root.querySelector('script[data-initial-translations]');
    if (!el) { return {}; }
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function textWithBreaks(el) {
    if (!el) { return ''; }
    var clone = el.cloneNode(true);
    /* Raw line breaks in the HTML source are not visible line breaks; only <br>/<p> are. */
    var walker = (clone.ownerDocument || document).createTreeWalker(clone, NodeFilter.SHOW_TEXT, null);
    var tn;
    while ((tn = walker.nextNode())) { tn.nodeValue = tn.nodeValue.replace(/[\r\n]+/g, ''); }
    var brs = clone.querySelectorAll('br');
    for (var i = 0; i < brs.length; i++) { brs[i].replaceWith('\n'); }
    var ps = clone.querySelectorAll('p');
    if (ps.length) {
      var parts = [];
      for (var j = 0; j < ps.length; j++) { parts.push(ps[j].textContent.trim()); }
      return parts.join('\n\n').trim();
    }
    return clone.textContent.trim();
  }

  function photoUrl(href) {
    if (!href) { return ''; }
    if (href.indexOf('width=') > -1) { return href.replace(/width=\d+/, 'width=480'); }
    return href + (href.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  function parseReviewsFromHtml(html) {
    if (!html) { return []; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nodes = doc.querySelectorAll('.jdgm-rev');
    var list = [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var id = n.getAttribute('data-review-id');
      if (!id) { continue; }
      var ratingEl = n.querySelector('.jdgm-rev__rating');
      var timeEl = n.querySelector('.jdgm-rev__timestamp');
      var authorEl = n.querySelector('.jdgm-rev__author');
      var titleEl = n.querySelector('.jdgm-rev__title');
      var replyEl = n.querySelector('.jdgm-rev__reply-content');
      var picLinks = n.querySelectorAll('.jdgm-rev__pic-link');
      var pics = [];
      for (var p = 0; p < picLinks.length && p < 4; p++) {
        var u = photoUrl(picLinks[p].getAttribute('href') || picLinks[p].getAttribute('data-mfp-src'));
        if (u && /^https:\/\//.test(u)) { pics.push(u); }
      }
      list.push({
        id: id,
        rating: parseInt(ratingEl && ratingEl.getAttribute('data-score'), 10) || 0,
        date: (timeEl && timeEl.getAttribute('datetime')) || '',
        author: authorEl ? authorEl.textContent.trim() : '',
        verified: n.getAttribute('data-verified-buyer') === 'true',
        title: titleEl ? titleEl.textContent.trim() : '',
        body: textWithBreaks(n.querySelector('.jdgm-rev__body')),
        lang: n.getAttribute('data-review-language') || 'ja',
        votes: parseInt(n.getAttribute('data-thumb-up-count'), 10) || 0,
        pics: pics,
        reply: replyEl ? textWithBreaks(replyEl) : ''
      });
    }
    return list;
  }

  function addReviews(state, list) {
    var added = [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (state.ids[r.id]) { continue; }
      state.ids[r.id] = true;
      r.order = state.pool.length;
      state.pool.push(r);
      added.push(r);
    }
    return added;
  }

  function needsTranslation(r) {
    return !!(r.lang && r.lang !== 'ja' && !r.ja);
  }

  function applyMetafieldTranslations(state, list) {
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (!needsTranslation(r)) { continue; }
      var pre = state.translations[r.id] && state.translations[r.id].ja;
      if (pre && pre.body) {
        r.ja = { title: pre.title || '', body: String(pre.body).replace(/\r\n/g, '\n') };
      }
    }
  }

  /* Japanese translations from the Judge.me translation service (same service the
     Judge.me widget uses in browsers without a built-in translator, e.g. Safari).
     Resolves to true when at least one review got a translation. Never rejects. */
  function translateWithJudgeme(state, list, page) {
    var todo = list.filter(needsTranslation);
    if (!todo.length || !state.shop) { return Promise.resolve(false); }
    var chunks = [];
    for (var i = 0; i < todo.length; i += 20) { chunks.push(todo.slice(i, i + 20)); }
    return Promise.all(chunks.map(function (chunk) {
      var url = TRANSLATE_API + '?review_uuids=' + encodeURIComponent(chunk.map(function (r) { return r.id; }).join(',')) +
        '&shop_domain=' + encodeURIComponent(state.shop) + '&language=ja&page=' + (page || 1);
      return fetchWithTimeout(url, 8000)
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (json) {
          var changed = false;
          if (!json) { return false; }
          for (var k = 0; k < chunk.length; k++) {
            var t = json[chunk[k].id];
            var body = t && t.body && t.body.success && t.body.translated_text;
            if (body) {
              var title = t.title && t.title.success && t.title.translated_text;
              chunk[k].ja = { title: title || '', body: String(body).replace(/\r\n/g, '\n') };
              changed = true;
            }
          }
          return changed;
        })
        .catch(function () { return false; });
    })).then(function (res) { return res.indexOf(true) > -1; });
  }

  function fetchWithTimeout(url, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
    var req;
    try {
      req = fetch(url, ctrl ? { credentials: 'omit', signal: ctrl.signal } : { credentials: 'omit' });
    } catch (e) {
      if (timer) { clearTimeout(timer); }
      return Promise.reject(e);
    }
    return req
      .then(function (res) { if (timer) { clearTimeout(timer); } return res; },
        function (err) { if (timer) { clearTimeout(timer); } throw err; });
  }

  function sorted(state) {
    var list = state.pool.slice();
    switch (state.sort) {
      case 'recent':
        list.sort(function (a, b) { return (b.date > a.date ? 1 : b.date < a.date ? -1 : 0); });
        break;
      case 'rating':
        list.sort(function (a, b) { return (b.rating - a.rating) || (a.order - b.order); });
        break;
      case 'photos':
        var withPics = list.filter(function (r) { return r.pics.length > 0; });
        if (withPics.length) { list = withPics; }
        break;
      case 'helpful':
        list.sort(function (a, b) { return (b.votes - a.votes) || (a.order - b.order); });
        break;
      default:
        list.sort(function (a, b) { return a.order - b.order; });
    }
    return list;
  }

  /* ---------- rendering ---------- */

  function formatDate(iso) {
    if (!iso) { return ''; }
    var d = new Date(iso);
    if (isNaN(d.getTime())) { return ''; }
    return d.getFullYear() + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2);
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) { e.className = cls; }
    if (text) { e.textContent = text; }
    return e;
  }

  function buildStars(rating) {
    var wrap = el('div', 'bfree-rv__card-stars');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', '5点中' + rating + '点');
    for (var s = 1; s <= 5; s++) {
      var star = el('span', s <= rating ? '' : 'is-off', '★');
      wrap.appendChild(star);
    }
    return wrap;
  }

  function buildCard(state, r) {
    var card = el('div', 'bfree-rv__card');
    card.appendChild(buildStars(r.rating));

    var titleEl = r.title ? el('p', 'bfree-rv__card-title', r.title) : null;
    var bodyEl = el('p', 'bfree-rv__card-body', r.body);
    if (titleEl) { card.appendChild(titleEl); }
    card.appendChild(bodyEl);

    if (r.lang && r.lang !== 'ja') { setupTranslation(state, r, card, titleEl, bodyEl); }

    if (r.pics.length) {
      var box = el('div', 'bfree-rv__photos' + (r.pics.length > 1 ? ' is-multi' : ''));
      for (var i = 0; i < r.pics.length; i++) {
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = (r.author || 'お客様') + 'さんの投稿写真';
        img.src = r.pics[i];
        box.appendChild(img);
      }
      card.appendChild(box);
    }

    var meta = el('div', 'bfree-rv__meta');
    if (r.author) { meta.appendChild(el('span', 'bfree-rv__author', r.author)); }
    if (r.verified) { meta.appendChild(el('span', 'bfree-rv__verified', '認証済みの購入者')); }
    var date = formatDate(r.date);
    if (date) { meta.appendChild(el('span', 'bfree-rv__date', date)); }
    card.appendChild(meta);

    if (r.reply) {
      var reply = el('div', 'bfree-rv__reply');
      reply.appendChild(el('span', 'bfree-rv__reply-label', 'B Free Japanからの返信'));
      reply.appendChild(el('span', 'bfree-rv__reply-body', r.reply));
      card.appendChild(reply);
    }
    return card;
  }

  function languageName(lang) {
    try {
      if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
        return new Intl.DisplayNames(['ja'], { type: 'language' }).of(lang) || lang;
      }
    } catch (e) {}
    return ({ en: '英語', zh: '中国語', ko: '韓国語', fr: 'フランス語', de: 'ドイツ語', es: 'スペイン語' })[String(lang).split('-')[0]] || lang;
  }

  /* Translation: Japanese text from the metafield or the Judge.me translation service
     (already stored in r.ja), otherwise the browser's built-in translator. */
  function setupTranslation(state, r, card, titleEl, bodyEl) {
    var original = { title: r.title, body: r.body };
    var btn = el('button', 'bfree-rv__translate');
    btn.type = 'button';
    var showingJa = false;

    function show(ja) {
      if (ja) {
        if (titleEl && r.ja.title) { titleEl.textContent = r.ja.title; }
        bodyEl.textContent = r.ja.body || original.body;
        btn.textContent = '原文を表示（' + languageName(r.lang) + '）';
      } else {
        if (titleEl) { titleEl.textContent = original.title; }
        bodyEl.textContent = original.body;
        btn.textContent = r.ja ? '日本語訳を表示' : 'レビューを日本語に翻訳';
      }
      showingJa = ja;
    }

    if (r.ja) {
      show(true);
    } else if (!browserCanTranslate()) {
      return;
    } else {
      btn.textContent = 'レビューを日本語に翻訳';
      browserAvailability(r.lang).then(function (status) {
        if (status === 'available') { translateWithBrowser(r).then(function (ok) { if (ok) { show(true); } }); }
      });
    }

    btn.addEventListener('click', function () {
      if (r.ja) { show(!showingJa); return; }
      btn.disabled = true;
      translateWithBrowser(r).then(function (ok) {
        btn.disabled = false;
        if (ok) { show(true); }
      });
    });
    card.appendChild(btn);
  }

  function browserCanTranslate() {
    return typeof window.Translator !== 'undefined' && typeof window.Translator.create === 'function';
  }

  function browserAvailability(lang) {
    try {
      return window.Translator.availability({ sourceLanguage: lang, targetLanguage: 'ja' })
        .catch(function () { return 'unavailable'; });
    } catch (e) { return Promise.resolve('unavailable'); }
  }

  function translateWithBrowser(r) {
    try {
      return window.Translator.create({ sourceLanguage: r.lang, targetLanguage: 'ja' }).then(function (t) {
        return Promise.all([
          r.title ? t.translate(r.title) : Promise.resolve(''),
          t.translate(r.body)
        ]).then(function (res) {
          r.ja = { title: res[0], body: res[1] };
          return true;
        });
      }).catch(function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }

  /* B Free reply: clamped to 4 lines; "続きを読む" opens the full text when it is longer. */
  function setupReplyToggle(card) {
    var reply = card.querySelector('.bfree-rv__reply');
    var body = reply && reply.querySelector('.bfree-rv__reply-body');
    if (!body || body.scrollHeight - body.clientHeight < 2) { return; }
    var btn = el('button', 'bfree-rv__reply-toggle');
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    var label = el('span', '', '続きを読む');
    btn.appendChild(label);
    btn.insertAdjacentHTML('beforeend', '<svg width="10" height="7" viewBox="0 0 10 7" aria-hidden="true"><path d="M1 1.5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    btn.addEventListener('click', function () {
      var open = !reply.classList.contains('is-open');
      reply.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? '閉じる' : '続きを読む';
    });
    reply.appendChild(btn);
  }

  function colCount() {
    var w = window.innerWidth;
    if (w < 768) { return 1; }
    if (w < 1024) { return 2; }
    return 3;
  }

  function render(root, columnsEl, state) {
    var list = sorted(state);
    var visible = list.slice(0, state.shown);
    /* Keep the current height while rebuilding so the page never shrinks for a moment
       (browsers without scroll anchoring, e.g. Safari, would otherwise jump). */
    columnsEl.style.minHeight = columnsEl.offsetHeight + 'px';
    columnsEl.innerHTML = '';

    var n = Math.max(1, Math.min(colCount(), visible.length));
    var cols = [];
    for (var c = 0; c < n; c++) {
      var col = el('div', 'bfree-rv__col');
      columnsEl.appendChild(col);
      cols.push(col);
    }
    /* Place each card in the currently shortest column so the grid stays balanced. */
    for (var i = 0; i < visible.length; i++) {
      var target = cols[0];
      for (var k = 1; k < cols.length; k++) {
        if (cols[k].offsetHeight < target.offsetHeight) { target = cols[k]; }
      }
      var card = buildCard(state, visible[i]);
      target.appendChild(card);
      setupReplyToggle(card);
    }
    columnsEl.style.minHeight = '';
    state.displayed = visible.map(function (r) { return r.id; });
    updateMoreButton(root, state, list.length);
  }

  /* "もっと見る": add only the new cards below the ones already shown, so the cards on
     screen (and the scroll position, open replies, original/translation toggles) stay as
     they are. Falls back to a full render when the order of shown cards would change. */
  function appendCards(root, columnsEl, state) {
    var list = sorted(state);
    var visible = list.slice(0, state.shown);
    var shown = state.displayed;
    var cols = [];
    for (var c = 0; c < columnsEl.children.length; c++) { cols.push(columnsEl.children[c]); }
    var sameStart = shown.length <= visible.length && cols.length === Math.max(1, Math.min(colCount(), visible.length));
    for (var j = 0; sameStart && j < shown.length; j++) {
      if (visible[j].id !== shown[j]) { sameStart = false; }
    }
    if (!sameStart) { render(root, columnsEl, state); return; }
    for (var i = shown.length; i < visible.length; i++) {
      var target = cols[0];
      for (var k = 1; k < cols.length; k++) {
        if (cols[k].offsetHeight < target.offsetHeight) { target = cols[k]; }
      }
      var card = buildCard(state, visible[i]);
      target.appendChild(card);
      setupReplyToggle(card);
      shown.push(visible[i].id);
    }
    updateMoreButton(root, state, list.length);
  }

  function updateMoreButton(root, state, listLength) {
    var btn = root.querySelector('[data-more]');
    if (!btn) { return; }
    var hasMore = listLength > state.shown || !state.exhausted;
    btn.hidden = !hasMore;
  }

  function setupSort(root, columnsEl, state) {
    var select = root.querySelector('[data-sort]');
    var label = root.querySelector('[data-sort-current]');
    if (!select || !columnsEl) { return; }
    select.addEventListener('change', function () {
      state.sort = select.value;
      state.shown = STEP;
      if (label) { label.textContent = select.options[select.selectedIndex].text; }
      render(root, columnsEl, state);
    });
  }

  function setupWriteReview(root) {
    var btn = root.querySelector('[data-write-review]');
    if (!btn) { return; }
    var labelHtml = btn.innerHTML;

    function modalOpen() {
      var m = document.querySelector('.jdgm-write-review-modal');
      return !!(m && window.getComputedStyle(m).display !== 'none');
    }
    function finish() { btn.disabled = false; btn.innerHTML = labelHtml; }

    btn.addEventListener('click', function () {
      if (btn.disabled) { return; }
      btn.disabled = true;
      var started = Date.now();
      var lastClick = 0;
      (function attempt() {
        /* Click the Judge.me "write a review" link. The first click may only prepare the
           review form (modal), so click again until it is open (max ~15 s). */
        if (modalOpen()) { finish(); return; }
        var now = Date.now();
        var link = document.querySelector('.jdgm-write-rev-link');
        if (link && now - lastClick > 1200) { lastClick = now; link.click(); }
        if (now - started > 600) { btn.textContent = '準備中…'; }
        if (now - started > 15000) { finish(); return; }
        setTimeout(attempt, 300);
      })();
    });
  }

  /* Fetch the next page of reviews from the official Judge.me widget endpoint (public token). */
  function fetchNextPage(state) {
    if (state.exhausted) { return Promise.resolve(0); }
    if (state.loading) { return state.loading; }
    var page = state.page + 1;
    var url = API + '?api_token=' + encodeURIComponent(state.token) +
      '&shop_domain=' + encodeURIComponent(state.shop) +
      '&handle=' + encodeURIComponent(state.handle) +
      '&per_page=' + PER_PAGE + '&page=' + page;
    state.loading = fetchWithTimeout(url, 15000)
      .then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.json();
      })
      .then(function (json) {
        if (!json || typeof json.widget !== 'string') { throw new Error('bad response'); }
        var list = parseReviewsFromHtml(json.widget);
        var added = addReviews(state, list);
        state.page = page;
        state.error = false;
        if (list.length < PER_PAGE || state.pool.length >= state.total) { state.exhausted = true; }
        return translateWithJudgeme(state, added, page).then(function () {
          state.loading = null;
          return added.length;
        });
      })
      .catch(function () {
        /* Keep the button so the visitor can try again (no permanent hiding). */
        state.loading = null;
        state.error = true;
        return 0;
      });
    return state.loading;
  }

  /* Keep fetching until there are enough reviews for the next "もっと見る" step (or none left). */
  function ensureEnough(state, needed) {
    if (sorted(state).length >= needed || state.exhausted) { return Promise.resolve(); }
    return fetchNextPage(state).then(function () {
      if (state.error) { return; }
      return ensureEnough(state, needed);
    });
  }

  function setupMore(root, columnsEl, state) {
    var btn = root.querySelector('[data-more]');
    if (!btn) { return; }
    var msg = el('p', 'bfree-rv__error', '読み込みに失敗しました。もう一度お試しください。');
    msg.hidden = true;
    msg.setAttribute('role', 'status');
    btn.parentNode.appendChild(msg);
    btn.addEventListener('click', function () {
      if (btn.disabled) { return; }
      var target = state.shown + STEP;
      var before = sorted(state).length;
      state.error = false;
      msg.hidden = true;
      btn.disabled = true;
      btn.textContent = '読み込み中…';
      ensureEnough(state, target).then(function () {
        btn.disabled = false;
        btn.textContent = 'もっと見る';
        var now = sorted(state).length;
        if (state.error && now <= state.shown) { msg.hidden = false; updateMoreButton(root, state, now); return; }
        state.shown = target;
        appendCards(root, columnsEl, state);
        if (state.error && now === before) { msg.hidden = false; }
      });
    });
  }

  /* Prefetch one page when the section gets close to the screen, so the first click is instant. */
  function setupPrefetch(root, state) {
    if (state.exhausted) { return; }
    if (!('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          io.disconnect();
          fetchNextPage(state).then(function () {
            var cols = root.querySelector('[data-columns]');
            if (cols) { updateMoreButton(root, state, sorted(state).length); }
          });
          return;
        }
      }
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  }

  /* Older browsers without CSS :has(): hide the Judge.me widget section from JS instead. */
  function hideNativeWidgetFallback() {
    try { if (window.CSS && CSS.supports && CSS.supports('selector(:has(*))')) { return; } } catch (e) {}
    var w = document.querySelector('.jdgm-review-widget');
    var sec = w && w.closest('.shopify-section');
    if (sec) { sec.style.display = 'none'; }
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bfree-reviews]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
